<div class="wrap_search_box">
    <app-field-group class="input_group_search" [class.loading]="loading()" [merge]="true">
        <input 
            id="table_search_input"
            name="table_search_input"
            type="text"
            appFormInputField 
            [readonly]="loading()"
            [formControl]="tableState.searchFormControl"
            [attr.aria-label]="'TABLE.SEARCH.ARIA_LABEL' | translate"
            [placeholder]="'TABLE.SEARCH.PLACEHOLDER' | translate"
            (onChange)="onSearchValueChange($event)"
        />
        <span class="bg-transparent" appElementTemplate="groupText">
            <i
                class="fa-regular"
                [class.fa-spin]="loading()"
                [class.fa-search]="!loading()"
                [class.fa-spinner]="loading()"
            >
            </i>
        </span>
    </app-field-group>
</div>

